"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBackground = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledBackground = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${theme_1.gradients.background.blue};
  z-index: -1;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${theme_1.gradients.background.red};
    mix-blend-mode: multiply;
  }
  ${({ customStyles }) => customStyles || {}}
`;
//# sourceMappingURL=styles.js.map